import React, { memo } from 'react';

import { Box, Typography } from '@rbilabs/universal-components';
import { ScrollView, StyleSheet } from 'react-native';

import { styleToNumber } from 'utils/style/style-to-number';

import { OptionsListWrapper, StyledOptionsListItem } from './styles';
import { AutocompletePrediction } from './types';

type DropdownContentProps = {
  predictions: AutocompletePrediction[] | undefined | null;
  noPredictionsFoundText: string;
  highlightedItemId: string | null;
  onSelect: (item: AutocompletePrediction) => void;
};

export const DropdownContent = memo(
  ({ predictions, noPredictionsFoundText, highlightedItemId, onSelect }: DropdownContentProps) => {
    if (!predictions?.length) {
      return (
        <OptionsListWrapper>
          <StyledOptionsListItem disabled>
            <Typography fontSize="2xs">{noPredictionsFoundText}</Typography>
          </StyledOptionsListItem>
        </OptionsListWrapper>
      );
    }

    return (
      <OptionsListWrapper>
        <ScrollView
          style={styles.scrollView}
          keyboardShouldPersistTaps="always"
          nestedScrollEnabled
        >
          {predictions.map(item => (
            <StyledOptionsListItem
              key={item.placeId}
              onPress={() => onSelect(item)}
              isHighlighted={highlightedItemId === item.placeId}
            >
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="flex-start"
                testID="address-suggestion"
                alignItems="stretch"
                accessible
                accessibilityLabel={`${item.mainText} ${item.secondaryText}`}
                accessibilityRole="menuitem"
              >
                <Typography fontSize="xs" bold mr="$1">
                  {item.mainText}
                </Typography>
                <Typography fontSize="xs" numberOfLines={1}>
                  {item.secondaryText}
                </Typography>
              </Box>
            </StyledOptionsListItem>
          ))}
        </ScrollView>
      </OptionsListWrapper>
    );
  }
);

const styles = StyleSheet.create({
  scrollView: {
    borderBottomLeftRadius: styleToNumber(Styles.borderRadius),
    borderBottomRightRadius: styleToNumber(Styles.borderRadius),
    overflow: 'hidden',
  },
});
